import 'react-select/dist/react-select.css';

import React from 'react';
import ReactSelect from 'react-select';
import get from 'lodash/get';

import { FormMeta, SelectOptions } from 'common/components/Form/propTypes';
import propTypes from 'prop-types';

class Select extends React.Component {
  static propTypes = {
    options: SelectOptions,
    input: propTypes.object.isRequired,
    meta: FormMeta.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.input.value,
    };
  }

  shouldComponentUpdate(nextProps) {
    if (
      get(this.props.currentValue, 'value') !==
      get(nextProps.currentValue, 'value')
    ) {
      this.handleChange(nextProps.currentValue);
    }
    return true;
  }

  handleChange = option => {
    if (!option) {
      return;
    }

    this.setState({ value: option.value });
    this.props.input.onChange(option.value);
  };

  render() {
    const { meta, input, className, ...props } = this.props;
    const { name } = input;
    const { touched, error, warning } = meta;
    return (
      <div className={className}>
        <div className="Field--select">
          <ReactSelect
            clearable={false}
            searchable={true}
            name={name}
            value={this.state.value}
            onChange={this.handleChange}
            {...props}
          />
        </div>
        {touched &&
          ((error && <div className="Field__error">{error}</div>) ||
            (warning && <div className="Field__warning">{warning}</div>))}
      </div>
    );
  }
}

export default Select;
